import { Message, MessageBox } from 'element-ui';
import apiUrl from "./devApi";
import axios from 'axios';
import { getToken } from '@/utils/auth';
import Qs from 'qs';
import store from '@/store';
import { getCache, setCache } from './apiCache';

let baseURL = process.env;
if(process.env.NODE_ENV == "development") {
    baseURL = Object.assign({}, process.env, apiUrl);
    console.warn('DEV URL:', baseURL.VUE_APP_API_FW);
}

const service = axios.create({
    baseURL: baseURL.VUE_APP_API_FW // api的base_url
    // timeout: 6000 // 请求超时时间
});

let pending = {};
let timers = {};
const CancelToken = axios.CancelToken;

// request拦截器
service.interceptors.request.use(config => {
    config.headers['X-Token'] = getToken() || '';

    // 更具name判断使用哪个API入口
    switch (config.name) {
        case 'xdApi' : config.baseURL = baseURL.VUE_APP_API_XD; break;
        case 'upload' : config.baseURL = baseURL.VUE_APP_API_YUN; break;
        case 'zyz' : config.baseURL = baseURL.VUE_APP_API_ZYZ; break;
        case 'ppt' : config.baseURL = baseURL.VUE_APP_API_PPT; break;
    }

    // 请求前做数据处理
    if(config.params && typeof config.params === "object") {
        config.params.moduleId = store.getters.routerId;
    }else if(config.params == null || typeof config.params == "undefined") {
        config.params = {
            moduleId: store.getters.routerId
        };
    }

    // 防止短时间多次提交
    if(config.method === "post") {
        const requestData = getRequestIdentify(config, true);
        config.cancelToken = new CancelToken((c) => {
            if(pending[requestData]) {
                c("操作过于频繁，请刷新网页后再试！");
                const timer = setTimeout(() => { // 如果请求超过5秒自动去除拦截
                    pending = {};
                }, 3000);
                timers[requestData] = timer;
            }else {
                pending[requestData] = c;
            }
        });
    }

    if(config.data && config.data.constructor == FormData || config.json) {
        // 不做处理
    }else {
        // 主要用于导出接口, x-www-form-urlencoded
        config.data = Qs.stringify(config.data);
    }

    return config;
}, error => {
    console.error("request", error);
    Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(response => {
    const { config, data } = response;
    if(config.method === 'post') {
        const requestData = getRequestIdentify(config, false);
        const timer = timers[requestData];
        if(timer) {
            clearTimeout(timer);
            delete timers[requestData];
        }
        delete pending[requestData];
    }

    // 当前响应数据为流数据时
    if(config.responseType && config.responseType == "arraybuffer") {
        return response;
    }
    if(data.msgCode == '1000' || data.msgCode == '4088') {
        return data;
    }else {
        if(!config.hiddenPopup) {
            if(config.errorAlert) {
                MessageBox.alert(data.msg, "提示", {
                    type: "warning",
                    center: true
                });
            }else {
                var msgType = 'error';
                if(config.msgType && (['success', 'warning', 'info', 'error'].find(d => d == config.msgType))) {
                    msgType = config.msgType;
                }
                Message({
                    message: data.msg,
                    type: msgType,
                    duration: 5 * 1000
                });
            }
        }
        if(data.msgCode == 15) {
            Message({
                message: "您的登录失效，请重新登录！",
                type: 'error',
                duration: 5 * 1000
            });
            store.dispatch('FedLogOut').then(() => {
                location.reload();
            });
        }
        return Promise.reject(data);
    }
},
error => {
    console.error('response', error);// for debug
    let msg = error.message;
    if(msg.indexOf("Network") != -1) {
        msg = "网络不稳定，请刷新后再试!";
        pending = {};
        timers = {};
    }
    Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000
    });
    return Promise.reject(error);
});


// 相同请求连接，不同参数的连接处理
function getRequestIdentify(config, isRequest = false) {
    let url = config.url;
    if(isRequest) {
        // 发送请求时，url未拼接host。响应请求时，url有host
        const baseURL = config.baseURL.replace(/\/+$/, '');
        url = baseURL + config.url;
    }
    return config.method === 'get' ? encodeURIComponent(url + JSON.stringify(config.params)) : url;
}

function requestProxy(config) {
    const cachedData = getCache(config);
    if(cachedData) {
        return Promise.resolve(cachedData);
    }
    return service(config).then(response => {
        setCache(config, response);
        return response;
    });
}

export default requestProxy;
